import { j as a } from "./jsx-runtime-DmTjM30f.mjs";
import { forwardRef as b, useState as v, useMemo as j, cloneElement as N, useCallback as w, Children as y } from "react";
import { c as x } from "./tw-cn-mXgPecoF.mjs";
const l = {
  unselected: "size-22",
  touchdown: "size-18",
  // 18x18
  touchup: "size-26"
  // 26x26
}, z = b((m, p) => {
  const { icon: s, activeIcon: o, title: i = "", link: u = "", isActive: r = !1, badge: d, ...e } = m, [t, n] = v(l.unselected), f = j(() => {
    const c = r && o || s;
    return c ? N(c, {
      ...c.props,
      className: x(`${c.props.className} transition-all duration-100 ${t} `, s == null ? void 0 : s.props.className)
    }) : null;
  }, [s, o, t, r]), g = () => {
    n(l.touchdown);
  }, h = () => {
    n(l.touchup), setTimeout(() => {
      n(l.unselected);
    }, 100);
  };
  return /* @__PURE__ */ a.jsxs(
    "a",
    {
      className: "relative flex h-56 items-center justify-center pb-4",
      href: u || void 0,
      onPointerDown: g,
      onPointerUp: h,
      ref: p,
      role: "button",
      title: i,
      ...e,
      children: [
        /* @__PURE__ */ a.jsxs("div", { className: "flex size-40 flex-col items-center overflow-hidden rounded-12 active:bg-opacity-black-5", children: [
          /* @__PURE__ */ a.jsx("div", { className: "m-auto flex size-26 max-h-26 min-h-26 items-center justify-center pb-2", children: f }),
          /* @__PURE__ */ a.jsx(
            "span",
            {
              className: x(
                `text-nowrap typography-label-10-regular-fixed ${o && r ? "!font-bold" : "font-normal"}`
              ),
              children: i
            }
          )
        ] }),
        d
      ]
    }
  );
});
z.displayName = "NDS.TabButton";
const S = b((m, p) => {
  const { children: s, onChange: o } = m, [i, u] = v(-1), r = w(() => {
    navigator.vibrate && navigator.vibrate(200);
  }, []), d = (e, t) => (n) => {
    r(), t == null || t(n), o == null || o(n, e), setTimeout(() => {
      u((f) => f === e ? -1 : e);
    }, 100);
  };
  return /* @__PURE__ */ a.jsxs(a.Fragment, { children: [
    /* @__PURE__ */ a.jsx("div", { className: "flex h-1 border-t border-t-opacity-black-10" }),
    /* @__PURE__ */ a.jsx(
      "nav",
      {
        className: "mx-auto grid w-full max-w-legacy-pc-size grid-cols-[repeat(auto-fit,minmax(0,1fr))] justify-center gap-0 bg-static-white px-8 pb-[env(safe-area-inset-bottom)]",
        ref: p,
        children: y.map(
          s,
          (e, t) => e ? N(e, {
            ...e.props,
            onClick: d(t, e.props.onClick),
            isActive: e.props.isActive ? !0 : i === t
          }) : null
        )
      }
    )
  ] });
});
S.displayName = "NDS.BottomNavigation";
export {
  S as B,
  z as T
};
